module.exports = __webpack_public_path__ + "static/apply-og-40f4d41ba069abee873e86f9084a082f.jpg";